module.exports = __webpack_public_path__ + "img/estrellaMargin.c478b0a4.svg";